import { useDoc } from '@/lib/firestore/hooks';
import { companyDoc } from '@/lib/firestore/refs';
import { activeSpecialHandling } from '@shared/crm';
import type { Company, SpecialHandlingNote } from '@shared/types';

export function SpecialHandlingNotes({ notes }: { notes: SpecialHandlingNote[] }) {
  if (!notes.length) return null;
  return (
    <>
      {notes.map((n, i) => (
        <div key={i} className={`announcement ${n.severity === 'critical' ? 'warning' : 'info'}`}><strong>Special handling:</strong> {n.text}</div>
      ))}
    </>
  );
}

/** Shows the company's active special-handling notes on any record linked to it. */
export function SpecialHandlingBanner({ companyId }: { companyId: string | null }) {
  const { data } = useDoc<Company>(companyId ? companyDoc(companyId) : null);
  return data ? <SpecialHandlingNotes notes={activeSpecialHandling(data)} /> : null;
}
